export default {
  toasts: {
    load_error: 'Ratele comisioanelor nu au putut fi încărcate',
    failed_to_save_changes: 'Modificările nu au putut fi salvate',
    changes_got_saved: 'Modificări salvate',
  },
  buttons: {
    edit: 'Editare',
    cancel: 'Anulare',
    save: 'Salvare',
  },
  rates: {
    title: 'Marjă de procesare',
    description:
      'Procent în %, plus o sumă fixă și una minimă opționale per tranzacție. „Orice metodă de plată” se aplică dacă nu există o rată specifică metodei.',
    default: {
      inherits:
        'Nu este setată nicio rată Adyen, deci restaurantele acestui partener care folosesc Adyen-ul FoodAmigos plătesc rata implicită FoodAmigos de mai jos. O rată setată aici o înlocuiește; o rată setată pentru un singur restaurant are în continuare prioritate.',
      overridden:
        'Rata Adyen proprie a acestui partener înlocuiește rata implicită FoodAmigos de mai jos pentru restaurantele sale care folosesc Adyen-ul FoodAmigos. Elimin-o pentru a reveni la rata implicită.',
      own_adyen:
        'Acest partener procesează plățile pe propriul cont Adyen. Restaurantele sale nu plătesc comision de procesare, cu excepția cazului în care o rată este setată aici sau pentru un singur restaurant.',
      master:
        'Acestea sunt ratele implicite FoodAmigos. Fiecare partener care folosește Adyen-ul FoodAmigos și nu are o rată Adyen proprie le utilizează.',
      rows_title: 'Ratele implicite FoodAmigos',
    },
  },
};
